module.exports = __webpack_public_path__ + "images/花筑院子全景_03.jpg?v=f6cac0d4";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu4/花筑院子全景_03.jpg
 ** module id = 71
 ** module chunks = 1 2
 **/